import { CircularProgress } from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

import { useGetPartitionById } from "../../services/use-partition-api";

type PartitionWidgetProps = {
    partitionId: guid;
};

function PartitionWidget(props: PartitionWidgetProps) {
    const { loading, data, error } = useGetPartitionById(props.partitionId);

    return (
        <>
            {loading && <CircularProgress size={"1rem"} aria-busy="true" />}
            {error && <SentimentVeryDissatisfiedIcon aria-label="icon" />}
            {data && (
                <span title={data.reference === null ? "" : data.name + "\n" + data.reference}>{data.name}</span>
            )}
        </>
    );
}

export default PartitionWidget;
